module.exports = __webpack_public_path__ + "static/media/faq_1.bdee77a7.svg";